// extracted by css-extract-rspack-plugin
export default {"chip-list":"ChipList_chip-list__zDdov"};